import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Backspace } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Login() {
  const [pin, setPin] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login, staff } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (staff) nav("/pos");
  }, [staff, nav]);

  const press = (n) => {
    if (pin.length >= 6) return;
    setPin(pin + n);
  };
  const back = () => setPin(pin.slice(0, -1));
  const clear = () => setPin("");

  const submit = async () => {
    if (pin.length < 4) return;
    setSubmitting(true);
    try {
      await login(pin);
      nav("/pos");
    } catch (e) {
      toast.error("Invalid PIN");
      setPin("");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-boba-cream boba-grain flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img
            src="https://customer-assets.emergentagent.com/job_boba-pos/artifacts/z8fez4xl_WhatsApp%20Image%202026-06-22%20at%209.29.05%20PM.jpeg"
            alt="Hizli"
            className="w-40 h-40 object-cover rounded-2xl mx-auto shadow-lg"
            data-testid="brand-logo"
          />
          <div className="text-xs uppercase tracking-[0.3em] font-mono text-boba-inkSoft mt-4">Bubble Tea · POS</div>
        </div>

        <div className="bg-white border border-boba-stoneLine rounded-md p-8">
          <h1 className="text-xl font-display font-bold mb-1">Enter your PIN</h1>
          <p className="text-sm text-boba-inkSoft mb-6">Login to start taking orders</p>

          <div className="flex justify-center gap-3 mb-6" data-testid="pin-dots">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className={`w-3 h-3 rounded-full border ${
                  i < pin.length
                    ? "bg-boba-matcha border-boba-matcha"
                    : "bg-transparent border-stone-300"
                }`}
              />
            ))}
          </div>

          <div className="grid grid-cols-3 gap-3">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
              <button
                key={n}
                onClick={() => press(String(n))}
                className="pin-key"
                data-testid={`pin-key-${n}`}
              >
                {n}
              </button>
            ))}
            <button onClick={clear} className="pin-key text-sm" data-testid="pin-key-clear">
              Clear
            </button>
            <button onClick={() => press("0")} className="pin-key" data-testid="pin-key-0">
              0
            </button>
            <button onClick={back} className="pin-key flex items-center justify-center" data-testid="pin-key-back">
              <Backspace size={24} />
            </button>
          </div>

          <button
            onClick={submit}
            disabled={pin.length < 4 || submitting}
            className="mt-6 w-full h-14 bg-boba-matcha hover:bg-boba-matchaDark text-white rounded-md text-lg font-semibold transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
            data-testid="pin-submit"
          >
            {submitting ? "Logging in…" : "Sign In"}
          </button>

          <div className="mt-6 text-center text-xs text-boba-inkSoft">
            <div className="font-mono">Demo: Manager → 1234 · Cashier → 0000</div>
          </div>
        </div>
      </div>
    </div>
  );
}
